export const validateIsraeliPhone = (phone: string): boolean => {
  if (!phone || !phone.trim()) return true; // Allow empty phone
  
  // Remove all non-digits
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Must be exactly 10 digits and start with 05
  return cleanPhone.length === 10 && cleanPhone.startsWith('05');
};

export const formatIsraeliPhone = (phone: string): string => {
  const cleanPhone = phone.replace(/\D/g, '');
  
  if (cleanPhone.startsWith('05') && cleanPhone.length === 10) {
    // Mobile format: 05X-XXX-XXXX
    return `${cleanPhone.substring(0, 3)}-${cleanPhone.substring(3, 6)}-${cleanPhone.substring(6)}`;
  }
  
  return phone; // Return original if can't format
};